export type SpaceUserRole = 'viewer' | 'owner' | 'contributor' | 'user' | 'unknown';
export type SpaceAction =
  | 'bot_manage'
  | 'bot_view'
  | 'chat_create'
  | 'chat_delete'
  | 'chat_edit'
  | 'chat_view'
  | 'message_create'
  | 'message_highlight'
  | 'message_pin_view'
  | 'message_pin'
  | 'message_speech_to_text'
  | 'message_text_to_speech'
  | 'message_unhighlight'
  | 'message_unpin'
  | 'message_edit'
  | 'record_create'
  | 'record_delete'
  | 'record_view'
  | 'space_archive'
  | 'space_clone'
  | 'space_delete'
  | 'space_edit'
  | 'space_settings_view'
  | 'space_share'
  | 'space_unarchive'
  | 'toc_view'
  | 'users_change_role'
  | 'users_view_role'
  | 'users_invite'
  | 'users_manage'
  | 'users_remove';

export const RolesPermissions: { [key in SpaceUserRole]: SpaceAction[] } = {
  owner: [
    'bot_manage',
    'bot_view',
    'chat_create',
    'chat_delete',
    'chat_edit',
    'chat_view',
    'message_create',
    'message_highlight',
    'message_pin_view',
    'message_pin',
    'message_speech_to_text',
    'message_text_to_speech',
    'message_unhighlight',
    'message_edit',
    'message_unpin',
    'record_create',
    'record_delete',
    'record_view',
    'space_archive',
    'space_clone',
    'space_delete',
    'space_edit',
    'space_share',
    'space_unarchive',
    'users_change_role',
    'users_invite',
    'users_manage',
    'users_remove',
  ],
  contributor: [
    'bot_manage',
    'bot_view',
    'chat_create',
    'chat_delete',
    'chat_edit',
    'chat_view',
    'message_create',
    'message_highlight',
    'message_pin_view',
    'message_pin',
    'message_speech_to_text',
    'message_text_to_speech',
    'message_unhighlight',
    'message_unpin',
    'record_create',
    'record_delete',
    'record_view',
    'space_archive',
    'space_clone',
    'space_unarchive',
    'users_invite',
    'users_manage',
    'users_change_role',
    'users_view_role',
  ],
  user: [
    'bot_view',
    'chat_create',
    'chat_edit',
    'chat_view',
    'message_create',
    'message_highlight',
    'message_pin_view',
    'message_pin',
    'message_speech_to_text',
    'message_text_to_speech',
    'message_unhighlight',
    'message_unpin',
    'record_view',
    'space_clone',
    'users_manage',
    'users_view_role',
  ],
  viewer: ['bot_view', 'chat_view', 'message_pin_view', 'message_text_to_speech', 'record_view', 'users_manage', 'users_view_role'],
  unknown: [],
};

export interface SpaceAccessControl {
  role: SpaceUserRole;
  permissions: SpaceAction[];
}
